import * as x from "react";
import { i as d, E as h, x as n, r as y, c as g } from "../createReactComponent-58f9bea8.mjs";
import { n as i } from "../property-9daa16cd.mjs";
import { e as c } from "../class-map-2994e95e.mjs";
import { S as v } from "../slot-controller-fa97ce97.mjs";
import { r as b } from "../icon-c572aa57.mjs";
import { T as f, r as _ } from "../link-7ef012bc.mjs";
import "../state-7560d4dc.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const k = d`
  :host div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--exo-spacing-standard);
    min-width: calc(var(--exo-size-3) - var(--exo-spacing-x-large));
    max-width: calc(var(--exo-size-8) - var(--exo-spacing-x-large));
  }

  :host .empty-state .empty-state__label {
    color: var(--exo-color-font);
    font: var(--exo-text-label-medium-bold);
    font-size: var(--exo-font-size-x-large);
    text-align: center;
  }

  :host .empty-state .empty-state__desc {
    font: var(--exo-text-body-medium);
    color: var(--exo-color-font-secondary);
    margin: var(--exo-spacing-none);
    text-align: center;
  }
`;
var u = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, r = (e, a, o, l) => {
  for (var p, s = l > 1 ? void 0 : l ? $(a, o) : a, m = e.length - 1; m >= 0; m--)
    (p = e[m]) && (s = (l ? p(a, o, s) : p(s)) || s);
  return l && s && u(a, o, s), s;
};
class t extends h {
  constructor() {
    super(...arguments), this.text = "Something went wrong!", this.label = "No Results", this.link = "", this.linkLabel = "", this.linkTarget = f.BLANK, this.slotController = new v(this, "action");
  }
  render() {
    const a = { "empty-state__empty": !0, hide: !this.slotController.test("empty") }, o = { "empty-state__button": !0, hide: !this.slotController.test("action") };
    return n`
      <div class="empty-state">
        <div class=${c(a)}>
          <slot name="header"></slot>
        </div>
        ${this.label ? n`<label class="empty-state__label">${this.label}</label>` : ""}
        ${this.text ? n`<p class="empty-state__desc">${this.text}</p>` : ""}
        ${this.linkLabel ? n`<div class="empty-state__link">
              <ex-link
                href="${this.link}"
                trailingicon="Open in new window"
                target="${this.linkTarget}"
                size="small"
              >
                ${this.linkLabel}
              </ex-link>
            </div>` : ""}
        <div class=${c(o)}>
          <slot name="action"></slot>
        </div>
      </div>
    `;
  }
}
t.styles = k, r([i()], t.prototype, "text", 2), r([i()], t.prototype, "label", 2), r([i()], t.prototype, "link", 2), r([i()], t.prototype, "linkLabel", 2), r([i()], t.prototype, "linkTarget", 2);
const w = (e = "") => {
  y("ex-empty-state", t, e), b(e), _(e);
}, P = g({ tagName: "ex-empty-state", elementClass: t, react: x, events: {}, displayName: "ExEmptyState", registerWebComponent: w });
export {
  P as ExEmptyState,
  w as register
};
